import './App.css';
import Layout from './components/Layout';

import NoMatch from './views/Noop';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WalletProvider from "./contexts/Wallet/WalletProvider";
import Mint from './views/Mint'
import Home from './views/Home'
import MySquad from '../src/views/MySquad'
import MyWarrior from '../src/views/MyWarrior'
import Synth from "./views/Synth/index";

function App() {
  
  return (
      <WalletProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />}/>
              <Route path='mint' element={<Mint />}/>
              <Route path='my' element={<MySquad />}/>
              <Route path='warrior' element={<MyWarrior />}/>
              <Route path='synth' element={<Synth />}/>
              <Route path="*" element={<NoMatch />} />
            </Route>
          </Routes>
        </BrowserRouter>      
      </WalletProvider>
  );
}

export default App;
